export const _ADMIN = {
    VERIFY_ADMIN_REQUEST : 'VERIFY_ADMIN_REQUEST',
    VERIFY_ADMIN_SUCCESS : 'VERIFY_ADMIN_SUCCESS',
    VERIFY_ADMIN_FAILURE : 'VERIFY_ADMIN_FAILURE',

    DELETE_ITEM_REQUEST : 'DELETE_ITEM_REQUEST',
    DELETE_ITEM_SUCCESS : 'DELETE_ITEM_SUCCESS',
    DELETE_ITEM_FAILURE : 'DELETE_ITEM_FAILURE',

    SUSPEND_ITEM_REQUEST : 'SUSPEND_ITEM_REQUEST',
    SUSPEND_ITEM_SUCCESS : 'SUSPEND_ITEM_SUCCESS',
    SUSPEND_ITEM_FAILURE : 'SUSPEND_ITEM_FAILURE',

    VERIFY_AGENT_REQUEST : 'VERIFY_AGENT_REQUEST', 
    VERIFY_AGENT_SUCCESS : 'VERIFY_AGENT_SUCCESS',
    VERIFY_AGENT_FAILURE : 'VERIFY_AGENT_FAILURE'
}